import deriveLinkComponents from '../associations/derive-link-components';
import api from '../REST/api';
import UserLink from './UserLink';

const { Link, Links } = deriveLinkComponents(UserLink, api.getUser);

export { Link as UserLink, Links as UserLinks };
